import React, { useState } from 'react'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import MenuItem from '@mui/material/MenuItem'

import DeliveryAddress from './DeliveryAddress'
import usePostingNoticeRequestContext from 'hooks/posting_notice_request/usePostingNoticeRequestContext'

function ShippingPackaging() {
  const {
    sortingOption,
    setSortingOption,
    stage,
    setStage,
    setShippingAddress,
  } = usePostingNoticeRequestContext()
  const [sortingOptionError, setSortingOptionError] = useState('')

  return (
    <Stack spacing={6}>
      <Box>
        <Typography variant="h2" mb={3} fontWeight={600} textAlign="left">
          Collation Selection
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <TextField
          fullWidth
          select
          required
          label="Sorting Option"
          value={sortingOption}
          onChange={(e) => setSortingOption(e.target.value)}
          error={Boolean(sortingOptionError)}
          helperText={sortingOptionError}
        >
          <MenuItem value="by-form">
            By Form (all copies of each form, then next form)
          </MenuItem>
          <MenuItem value="by-location">
            By Location (forms collated so each Quantity entry has all Forms
            linked to that state code)
          </MenuItem>
        </TextField>
      </Box>
      <Box>
        <Typography variant="h2" mb={3} fontWeight={600} textAlign="left">
          Confirm Shipping Address
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <DeliveryAddress
          onNext={(values) => {
            if (!sortingOption) {
              setSortingOptionError('Sorting Option is required')
            } else {
              setShippingAddress(values)
              setStage(stage + 1)
            }
          }}
        />
      </Box>
    </Stack>
  )
}

export default ShippingPackaging
